import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { tap } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { MyTicketsStatusEnum } from '../../enums/my-tickets-status-enum';
import { TranslateService } from '@ngx-translate/core';
import { TicketsApiService } from 'src/app/services/tickets.service';
import { MyTicketsMeta } from 'src/app/shared/models/my-tickets-meta.model';
import { saveAs } from 'file-saver';
import { HelpersService, HttpBaseService } from '@evento-ng/libs';
import {
  paymentsApi,
  publicPaymentsApi,
  userProfileApi,
} from 'src/app/services/constants/api.constants';
import { ApprovalStatusEnum } from 'src/app/services/enums/approval-status.enum';
import { DatePipe } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import { generateQR } from 'src/app/shared/utils/qr-code.util';
@Component({
  selector: 'app-my-tickets',
  templateUrl: './my-tickets.component.html',
  styleUrls: ['./my-tickets.component.scss'],
  providers: [DatePipe],
})
export class MyTicketsComponent implements OnChanges {
  @Input() myTicketsStatus!: MyTicketsStatusEnum;
  @Input() reload!: boolean;
  MyTicketsStatusEnum = MyTicketsStatusEnum;
  errorMessage!: string;
  successMessage!: any;
  ticketsPage!: number;
  ticketsTake!: number;
  tickets!: any[];
  ticketsMeta!: MyTicketsMeta;

  @Output() ticketsData: EventEmitter<any> = new EventEmitter();
  @Output() emitErrorMessage = new EventEmitter<string>();
  @Output() emitSuccessMessage = new EventEmitter<string>();

  ApprovalStatusEnum = ApprovalStatusEnum;
  formattedDate!: any;
  constructor(
    private spinner: NgxSpinnerService,
    public helpers: HelpersService,
    public translate: TranslateService,
    public ticketApiService: TicketsApiService,
    private dataService: HttpBaseService,
    private datePipe: DatePipe
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes['myTicketsStatus'] && changes['myTicketsStatus'].currentValue) ||
      (changes['formValues'] && changes['formValues'].currentValue) ||
      (changes['reload'] && changes['reload'].currentValue)
    ) {
      this.ticketsPage = 1;
      this.getTickets();
    }
  }

  formatDate(date: any) {
    const formatString = 'EEEE dd MMMM yyyy';
    this.formattedDate = this.datePipe.transform(
      date,
      formatString,
      undefined,
      this.translate.currentLang
    );
    return this.formattedDate;
  }

  downloadTicket(ticketId: string): void {
    this.spinner.show();
    this.dataService
      .get(`${publicPaymentsApi}/${ticketId}/download`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/pdf',
        }),
        responseType: 'blob' as 'json',
      })
      .pipe(
        tap(
          (res) => {
            saveAs(res, ticketId + '.pdf');
            this.spinner.hide();
          },
          (err) => {
            this.spinner.hide();
            this.successMessage = null;
            this.errorMessage = err.message;
            this.emitErrorMessage.emit(this.errorMessage);
          }
        )
      )
      .subscribe();
  }

  getTickets(): void {
    this.spinner.show();
    this.dataService
      .get(`${userProfileApi}/tickets`, {
        params: {
          page: this.ticketsPage,
          take: 10,
          current: this.myTicketsStatus,
        },
        headers: {
          'Accept-Language': this.translate.currentLang,
        },
      })
      .subscribe(
        (res) => {
          this.ticketsMeta = res.meta;
          this.tickets = res.data.map((ticket: any) => {
            const invoiceAddons = ticket.invoiceAddons || [];

            return {
              ...ticket,
              whatsAppObject: invoiceAddons.find(
                (addon: any) => addon.eventAddon?.type === 'WHATSAPP_TICKETS'
              ),
              serviceChargesObject: invoiceAddons.find(
                (addon: any) => addon.eventAddon?.type === 'SERVICE_CHARGE'
              ),
            };
          });

          this.spinner.hide();
        },
        (err) => {
          this.spinner.hide();
          this.successMessage = null;
          this.errorMessage = err.error;
          this.emitErrorMessage.emit(this.errorMessage);
        }
      );
  }

  toggleExpand(ticket: any) {
    ticket.expanded = !ticket.expanded;
    if (ticket.expanded) {
      this.getOrdersWithApprovalStatus(ticket.id);
    }
  }

  async getOrdersWithApprovalStatus(ticketId: any) {
    this.spinner.show();

    this.dataService.get(`${paymentsApi}/${ticketId}`).subscribe({
      next: async (res: any) => {
        const updatedOrders = res.orders || [];

        for (const order of updatedOrders) {
          order.generatedQrCode = await generateQR(order.id);

          order.mutedQrCode = await generateQR(order.id, '#cecece');
        }

        this.tickets = this.tickets.map((item) => {
          if (item.id === ticketId) {
            return {
              ...item,
              orders: updatedOrders,
            };
          }
          return item;
        });

        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }
  goToPage(n: number): void {
    this.ticketsPage = n;
    this.getTickets();
  }

  onNext(): void {
    this.ticketsPage++;
    this.getTickets();
  }

  onPrev(): void {
    this.ticketsPage--;
    this.getTickets();
  }
}
